const state = {
	ordersShipping: {},
	shippingRates: {},
	showLoading: false
};

const mutations = {
	SET_ORDERS_SHIPPING(state, payload) {
		state.ordersShipping = payload;
	},
	SET_SHIPPING_RATES(state, payload) {
		state.shippingRates = payload;
	},
	SET_SHOW_LOADING(state, payload) {
		state.showLoading = payload;
	}
};

const actions = {
	async getShippingRates({ commit }) {
		await axios({
			url: "/general-data"
		}).then(async(response) => {
			if (response && response.data) {
				await commit("SET_SHIPPING_RATES", JSON.parse(response.data[0].data_value));
				await commit("SET_ORDERS_SHIPPING", JSON.parse(response.data[1].data_value));
			}
		}).catch(() => { });
	},
	setShowLoading({ commit }, payload) {
		commit("SET_SHOW_LOADING", payload);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};